
namespace RioERP.Reports {
    export class OrderTransactionReportColumns {
        static columnsKey = 'Reports.OrderTransactionReport';
    }
}